<template>
  <div class="l-subSidebar">
    <slot name="heading"></slot>
    <div v-for="(category, j) in menuCategories" :key="j">
      <template v-if="checkCategoryPermission(category)">
        <div class="l-subSidebar__category">
          {{ category.name }}
        </div>
        <router-link
          v-for="(item, i) in category.items.filter(
            (item) =>
              item.situation == null ||
              currentUser.permittedSituations.includes(item.situation)
          )"
          :key="i"
          :to="item.router"
          class="l-subSidebar__item"
          exact-active-class="l-subSidebar__item--active"
        >
          {{ item.text }}
        </router-link>
      </template>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

export default {
  props: {
    headingLabel: {
      type: String,
      default: ''
    },
    menuCategories: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.UserStore.currentUser
    }),
    ...mapGetters('UserStore', ['judgePermissionBySituations'])
  },
  methods: {
    checkCategoryPermission: function (category) {
      const situations = category.items
        .map((item) => item.situation)
        .filter(Boolean)

      if (situations.length === 0) {
        return true
      }
      return this.judgePermissionBySituations(situations)
    }
  }
}
</script>

<style scoped lang="sass">
.l-subSidebar
  position: fixed
  z-index: 2
  padding: 0 30px 30px 20px
  width: 250px
  height: calc(100vh - 110px)
  border-right: 1px solid #E0E0E0
  color: #919191
  background: #fff
  font-family: "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro", "Yu Gothic Medium", "游ゴシック"
  overflow-y: scroll
  &__category
    font-size: .8rem
    padding-left: 8px
    margin-top: 30px
    margin-bottom: 10px
    letter-spacing: 1px
    font-weight: 600
  &__item
    display: block
    font-size: 1rem
    padding: 5px
    font-weight: 600
    padding-left: 20px
    letter-spacing: 2px
    color: #919191
    margin-bottom: 5px
    &--active
      color: #0B0202
    &:hover
      color: #0B0202
</style>
